module.exports = __webpack_public_path__ + "static/media/TA274_1.5322a268.png";